import { pickT } from "@repo/shared";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./spacer-form.i18n";
import type { ComponentFormProps } from "./types";

export type SpacerConfig = {
  height: number; // Height in cm
};

export function SpacerForm({ config, onChange }: ComponentFormProps<SpacerConfig>) {
  const t = useT(T);

  return (
    <div className="space-y-2">
      <Label htmlFor="spacer-height">
        {t.heightLabel} <span className="text-destructive">*</span>
      </Label>
      <Input
        id="spacer-height"
        type="number"
        min={0.1}
        max={20}
        step={0.1}
        value={config.height || ""}
        onChange={(e) => {
          const value = e.target.value ? parseFloat(e.target.value) : 1;
          onChange({ ...config, height: value });
        }}
        placeholder="1"
        className="w-32"
      />
      <p className="text-xs text-muted-foreground">{t.description}</p>
    </div>
  );
}

export function validateSpacerConfig(config: SpacerConfig, lang = "en_GB"): string | null {
  const t = pickT(T, lang);
  if (!config.height || config.height <= 0) {
    return t.validationError;
  }
  return null;
}

export function getDefaultSpacerConfig(): SpacerConfig {
  return {
    height: 1,
  };
}
